export const ASSISTED_REGISTRATION_ID_QUERY = "registrationId";
export const LEGACY_ASSISTED_LEAD_ID_QUERY = "leadId";
export const ASSISTED_REGISTRATION_NEW_QUERY = "new";

export const resolveAssistedRegistrationId = (data) => {
  const id =
    data?.registrationId ??
    data?.RegistrationId ??
    data?.leadId ??
    data?.LeadId ??
    null;
  const parsed = Number(id);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const readAssistedRegistrationIdFromQuery = (searchParams) => {
  const raw =
    searchParams.get(ASSISTED_REGISTRATION_ID_QUERY) ||
    searchParams.get(LEGACY_ASSISTED_LEAD_ID_QUERY);
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const buildAssistedRegistrationSearchParams = (registrationId) => ({
  [ASSISTED_REGISTRATION_ID_QUERY]: String(registrationId),
});
